module.exports = __webpack_public_path__ + "reminder.worker.js"